import { mfaApi } from '@api/mfa/mfa.api';

export const { useGenerateMfaMutation, useEnableMfaMutation, useDisableMfaMutation } = mfaApi;
